import { prefixHttps } from '@mondough/public-web-components'

const IMAGE_QUALITY = 90

// outputs: "cdn.monzo.com/img_name?w=250 250w, cdn.monzo.com/img_name?w=500 500w"
export const buildImageSourceSets = (imageWidths: number[], src: string) => {
  const PIXEL_DENSITIES = [1, 2]

  return (
    imageWidths
      // creates a flat array of all image widths
      .reduce((allImageWidths, width, index, array) => {
        PIXEL_DENSITIES.forEach(pixelDensity => {
          allImageWidths.push(pixelDensity * width)
        })
        return allImageWidths
      }, [])
      .sort((a, b) => a - b)
      .map(
        imageWidth =>
          `${prefixHttps(
            src,
          )}?w=${imageWidth}&q=${IMAGE_QUALITY} ${imageWidth}w`,
      )
      .join(', ')
  )
}

export const buildDefaultImage = (imageUrl: string, width: number) =>
  `${prefixHttps(imageUrl)}?w=${width}&q=${IMAGE_QUALITY}`
